import { useState, useEffect } from 'react';
import { RfidCodeMasterForm } from './RfidCodeMasterForm';
import { useSelector } from 'react-redux';
import { selectPrefix } from '../utility/Redux/profile';
import { selectToken } from '../utility/Redux/security';
import { CallAPIPromise } from '../routeBilling/menu/dashboard/biiling/modal/comman';



export function RfidCodeMasterList() {
  const [rfidCodes, setRfidCodes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(null);

  // Mock values - replace with actual values from your auth/config
  const prefix = useSelector(selectPrefix)
  const token = useSelector(selectToken)
  const [confirmDelete, setConfirmDelete] = useState(null);
  const fetchRfidCodes = async () => {
    setLoading(true);
    try {
      const response = await CallAPIPromise(
        'api/listRfidCodeMaster/listRfidCodeMaster/',
        {
          table_prefix: prefix,
          icode: '',
          from_epc: '',
          to_epc: '',
        },
        token
      );
      console.log(response)

      // Assuming the API returns an array of RFID codes
      setRfidCodes(response.data?.data || []);
    } catch (error) {
      console.error('Failed to fetch RFID codes:', error);
      // Mock data for demonstration
      setRfidCodes([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRfidCodes();
  }, [deleteLoading]);

  const handleDelete = async (id,from,to) => {
    // if (!confirm('Are you sure you want to delete this RFID code?')) {
    //   return;
    // }

    setDeleteLoading(id);
    try {
      await CallAPIPromise(
        'api/rfidDelete/deleteRfidCodeMaster',
        {
          icode: id, table_prefix: prefix, from_epc: from,
          to_epc:to
        },
        token
      );

      // Remove from local state
    } catch (error) {
      console.error('Failed to delete RFID code:', error);
    } finally {
      setDeleteLoading(null);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 p-8">
      <div className="max-w-7xl mx-auto">
        <div className="flex justify-between items-center mb-8">
          <h1>RFID Code Master</h1>
          <button
            onClick={() => setShowModal(true)}
            className="bg-blue-600 text-white px-6 py-2 rounded-md hover:bg-blue-700 transition-colors"
          >
            + Create New
          </button>
        </div>

        {loading ? (
          <div className="flex justify-center items-center py-12">
            <div className="text-gray-500">Loading...</div>
          </div>
        ) : rfidCodes.length === 0 ? (
          <div className="bg-white rounded-lg shadow-md p-12 text-center">
            <p className="text-gray-500">No RFID codes found. Create your first one!</p>
          </div>
        ) : (
          <div className="bg-white rounded-lg shadow-md overflow-hidden">
            <table className="w-full">
              <thead className="bg-gray-50 border-b border-gray-200">
                <tr>
                  <th className="px-6 py-3 text-left text-sm text-gray-600">Item Code</th>
                  <th className="px-6 py-3 text-left text-sm text-gray-600">Item Name</th>
                  <th className="px-6 py-3 text-left text-sm text-gray-600">From EPC</th>
                  <th className="px-6 py-3 text-left text-sm text-gray-600">To EPC</th>
                  <th className="px-6 py-3 text-left text-sm text-gray-600">Actions</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {rfidCodes.map((code) => (
                  <tr key={code.id} className="hover:bg-gray-50">
                    <td className="px-6 py-4 text-sm">{code.icode}</td>
                    <td className="px-6 py-4 text-sm">{code.itemname || '-'}</td>
                    <td className="px-6 py-4 text-sm">{code.from_epc}</td>
                    <td className="px-6 py-4 text-sm">{code.to_epc}</td>
                    <td className="px-6 py-4 text-sm">
                    <button
  onClick={() => setConfirmDelete(code)}
  className="text-red-600 hover:text-red-800"
>
  Delete
</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
      {confirmDelete && (
  <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
    <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-md">
      
      <h2 className="text-lg font-semibold mb-2">Delete RFID Code?</h2>
      
      <p className="text-gray-600 mb-6">
        Are you sure you want to delete this RFID code?
        <br />
        <span className="font-medium">{confirmDelete.icode}</span>
      </p>

      <div className="flex justify-end gap-3">
        <button
          onClick={() => setConfirmDelete(null)}
          className="px-4 py-2 rounded-md border border-gray-300 hover:bg-gray-100"
        >
          Cancel
        </button>

        <button
          onClick={async () => {
            await handleDelete(confirmDelete.icode,confirmDelete.from_epc,confirmDelete.to_epc);
            setConfirmDelete(null);
          }}
          disabled={deleteLoading === confirmDelete.id}
          className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 disabled:bg-gray-400"
        >
          {deleteLoading === confirmDelete.id ? 'Deleting...' : 'Delete'}
        </button>
      </div>
    </div>
  </div>
)}

      {showModal && (
        <RfidCodeMasterForm
          onClose={() => setShowModal(false)}
          onSuccess={fetchRfidCodes}
          prefix={prefix}
          token={token}
        />
      )}
    </div>
  );
}
